import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WebStorage } from "./web-storage";

@Injectable({
  providedIn: "root",
})
export class FavoriteArgumentsService {
  private webStorage = inject(WebStorage);

  private productArgumentsIdsSubject = new BehaviorSubject<string[]>(
    this.webStorage.productArgumentsIdsIncluded ?? [],
  );
  private productArgumentsFavoritesStatus = new BehaviorSubject<boolean>(
    this.webStorage.showArgumentsFavorites ?? false,
  );
  includedDocumentIds$ = this.productArgumentsIdsSubject.asObservable();
  productArgumentsFavoriteStatus$ =
    this.productArgumentsFavoritesStatus.asObservable();

  setIdsIncluded(ids: string[]) {
    this.webStorage.productArgumentsIdsIncluded = ids ?? [];
    this.productArgumentsIdsSubject.next(
      this.webStorage.productArgumentsIdsIncluded,
    );
  }

  setFavoritesArgumentsStatus(status: boolean) {
    this.webStorage.showArgumentsFavorites = status;
    this.productArgumentsFavoritesStatus.next(
      this.webStorage.showArgumentsFavorites,
    );
  }

  remove(id: string) {
    if (id) {
      this.setIdsIncluded(
        this.webStorage.productArgumentsIdsIncluded.filter(
          (includedId) => includedId !== id,
        ),
      );
    }
  }
  add(id: string) {
    if (id) {
      const includedIds = this.webStorage.productArgumentsIdsIncluded;
      if (!includedIds.includes(id)) {
        this.setIdsIncluded([...includedIds, id]);
      }
    }
  }
}
